"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnimateTabIndicator = void 0;
var _react = require("react");
var _tabs = require("@cbhq/cds-common/animation/tabs");
var _usePreviousValues3 = require("@cbhq/cds-common/hooks/usePreviousValues");
var _useMotionProps = require("../../motion/useMotionProps");
const useAnimateTabIndicator = ({
  width,
  x
}) => {
  const _usePreviousValues = (0, _usePreviousValues3.usePreviousValues)([]),
    getPreviousWidth = _usePreviousValues.getPreviousValue,
    addPreviousWidth = _usePreviousValues.addPreviousValue;
  const _usePreviousValues2 = (0, _usePreviousValues3.usePreviousValues)([]),
    getPreviousX = _usePreviousValues2.getPreviousValue,
    addPreviousX = _usePreviousValues2.addPreviousValue;
  addPreviousWidth(width);
  addPreviousX(x);
  const property = _tabs.animateTabIndicatorBaseSpec.property,
    easing = _tabs.animateTabIndicatorBaseSpec.easing,
    duration = _tabs.animateTabIndicatorBaseSpec.duration;
  const widthMotionProps = (0, _useMotionProps.useMotionProps)({
    animate: {
      [property]: [getPreviousWidth(), width]
    },
    transition: {
      easing,
      duration
    }
  });
  const xMotionProps = (0, _useMotionProps.useMotionProps)({
    animate: {
      [property]: [getPreviousX(), x]
    },
    transition: {
      easing,
      duration
    }
  });
  return (0, _react.useMemo)(() => ({
    widthMotionProps,
    xMotionProps
  }), [widthMotionProps, xMotionProps]);
};
exports.useAnimateTabIndicator = useAnimateTabIndicator;